import { gsap } from 'gsap';
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { SplitText } from "gsap/SplitText";

gsap.registerPlugin(ScrollTrigger);
gsap.registerPlugin(SplitText);

const initGSAPWordScroll = () => {

	const telecomTextIntro = document.querySelector('.telecom-text-intro');

	if (!telecomTextIntro) return;

	let split = SplitText.create(".split-copy", { type: "words" });

	// Responsive start trigger: <768px = "top top", otherwise "top 20%"
	const isMobile = window.matchMedia("(max-width: 767px)").matches;
	const scrollStart = isMobile ? 'top -30px' : 'top 80%';

	gsap.to(split.words, {
		x: 0,
		opacity: 1,
		stagger: 0.01,
		ease: 'power4.inOut',
		scrollTrigger: {
			trigger: telecomTextIntro,
			start: scrollStart,
			end: 'bottom top',
			scrub: 1,
			pin: false,
		}
	});

}
export { initGSAPWordScroll };